
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.272 4.248l3.983 2.643c.01-.159.047-.308.047-.476A6.241 6.241 0 007.057.175a6.241 6.241 0 00-6.245 6.24 6.241 6.241 0 006.245 6.239c.065 0 .13-.019.196-.019V5.331c0-1.036 1.16-1.662 2.02-1.083z","fill":"#E3BFF8"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.253 5.332c0-1.037 1.15-1.662 2.02-1.083L13.253 6.9l.001-.01 3.843 2.55c.776.514.776 1.654 0 2.158l-7.826 5.202c-.86.57-2.019-.046-2.019-1.083V5.332z","fill":"#A127E8"}})])
          )
        }
      }
    